import assetsActions from '../imageAssets/actions';
import mapActions from '../map/actions';
import { resetMapViewMode } from '../map/thunks';

export const setSelectedProperty = () => (dispatch) => {
  dispatch(mapActions.setMapMode('idle'));
  dispatch(assetsActions.setSelectedSceneGroup(null));
  dispatch(assetsActions.setSelectedImages([]));
  dispatch(assetsActions.setSideSelectedSceneGroup(null));
  dispatch(assetsActions.setSideSelectedImages([]));
  dispatch({ type: assetsActions.RESET });
  dispatch(resetMapViewMode());
};
